export const UX_COPY_PT = {
  "quickNavAria": "Links rápidos para seções da página",
  "skipToSections": "Ir para o menu da seção",
  "jumpToStudioHint": "Atalho: Alt + S"
};

export const TRIAL_FLOW_COPY_PT = {
  "flowLabel": "Como funciona",
  "flowSteps": [
    "Escolha uma imagem para um teste rápido.",
    "Continue em Metadata Studio com o mercado escolhido.",
    "Revise e edite o resultado antes de exportar."
  ]
};

export const LANDING_SALES_COPY_PT = {};


export default LANDING_SALES_COPY_PT;
